import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const { authenticated, requires2FA, loading, user } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        fontSize: '20px'
      }}>
        Loading...
      </div>
    );
  }

  if (!authenticated) {
    return <Navigate to="/login" />;
  }

  if (requires2FA) {
    return <Navigate to="/verify-2fa" />;
  }

  // Check if user needs to setup 2FA (is2FAEnabled is false or force2FASetup is true)
  if (user && (user.force2FASetup || !user.is2FAEnabled)) {
    return <Navigate to="/setup-2fa" />;
  }

  // Check if specific role is required
  if (requiredRole && user && (!user.roles || !user.roles.includes(requiredRole))) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: '#f5f7fa',
        flexDirection: 'column',
        gap: '20px'
      }}>
        <h1 style={{ color: '#1a202c', margin: 0 }}>Access Denied</h1>
        <p style={{ color: '#718096', margin: 0 }}>You do not have permission to access this page.</p>
        <a href="/dashboard" style={{ color: '#667eea', textDecoration: 'none', fontWeight: 'bold' }}>
          Return to Dashboard
        </a>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
